import Head from 'next/head';
import React, { FC, ReactNode } from 'react';

interface LayoutProps {
  title?: string;
  description?: string;
  children: ReactNode;
}

export const Layout: FC<LayoutProps> = ({
  title = 'Toggle.ai',
  description = 'toggle.ai',
  children,
}) => {
  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
      </Head>
      {children}
    </>
  );
};
